export default __webpack_public_path__ + "static/media/down-arrow-white.cdc100b5.svg";